export default __webpack_public_path__ + "static/media/tiny.448432c1.png";